import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const StickyButtonsFooter = styled.div`
  ${tw`flex gap-3 px-6 py-4 justify-end sticky bottom-0 left-0 right-0 bg-white`}
`;
